import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';
import '../styles/booking.css';
import '../styles/responsive-utils.css';
import '../styles/customer-responsive.css';

function Booking() {
  const { salonId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [salonInfo, setSalonInfo] = useState(null);
  
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setLoading(true);
        
        // Get salon information
        const salonDocRef = doc(db, 'salons', salonId);
        const salonDoc = await getDoc(salonDocRef);
        
        if (!salonDoc.exists()) {
          throw new Error('Salon not found');
        }
        
        setSalonInfo(salonDoc.data());
        
        // Redirect to your existing BookingForm component
        navigate(`/salon/${salonId}/book`);
        
      } catch (error) {
        console.error('Error fetching initial data:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchInitialData();
  }, [salonId, navigate]);

  if (loading) {
    return <div className="booking-loading">Loading booking form...</div>;
  }
  
  if (error) {
    return <div className="booking-error">Error: {error}</div>;
  }

  // We shouldn't reach here because of the redirect
  return (
    <div className="booking-container">
      <div className="booking-content">
        <h1>Redirecting to booking form...</h1>
      </div>
    </div>
  );
}

export default Booking;